import { Connect } from "./connect.js";
import App from "../lib/app.js";

export class AccIntegrationConnect extends Connect {
  constructor() {
    const { apiKey, apiACCUrl, apiACCPrefix, origin } = App.config.apis.a2censo;
    const { login } = App.redux.store.getState();
    super(apiACCUrl, apiACCPrefix, {
      apiKey,
      Authorization: "Bearer " + login.idToken,
      Origin: origin,
      "x-more-info": login.moreInfo || "",
    });
  }

  async creditCreation(body) {
    const response = await this.request({
      method: "post",
      service: "credit-creation/create",
      body,
    });
    return Promise.resolve(response?.data);
  }

  async getTrackingACC(id) {
    const response = await this.request({
      headers: {
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
      },
      method: "get",
      service: `tracking-acc/${id}`,
    });
    return Promise.resolve(response?.data);
  }

  async downloadTA(id) {
    const response = await this.request({
      method: "get",
      service: `download-ta/${id}`,
    });
    return Promise.resolve(response?.data);
  }

  async investor(body) {
    const response = await this.request({
      method: "post",
      service: "investor/create",
      body,
    });
    return Promise.resolve(response?.data);
  }

  // Reintentar creación de pago
  // POST /acc/payment/create con creditID
  async retryPaymentCreate(body) {
    const response = await this.request({
      method: "post",
      service: "notications/retry_payments",
      body,
    });
    return Promise.resolve(response?.data);
  }
}
